import * as yup from 'yup';
import { useTranslation } from '~/shared/utils/translation';

import { isEmail } from '~/utils/form-validators';

/**
 * Yup documentaion https://github.com/jquense/yup
 * @returns validation schema
 */

export const useValidationSchema = () => {
    const { translate } = useTranslation();

    const validationShape = {
        email: yup
            .string()
            .matches(isEmail, translate('message.emailValidationError'))
            .required('')
            .max(50, translate('message.inputValidationError.toLong', { length: '50' })),
    };

    return yup.object().shape(validationShape);
};
